import { Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/auth/auth";
import { RealtimeProvider } from "@/realtime/useRealtime";
import { NavRail } from "./NavRail";
import { CommandPalette } from "./CommandPalette";
import { JarvisOverlay } from "@/jarvis/JarvisOverlay";
import { BootScreen } from "./BootScreen";
import { MobileShell } from "@/mobile/MobileShell";
import { useIsMobile } from "@/lib/useIsMobile";

/** Chráněný layout: vyžaduje přihlášení, drží WS spojení a globální shell. */
export function ShellLayout() {
  const { session, loading } = useAuth();
  const isMobile = useIsMobile();

  if (loading) return <BootScreen />;
  if (!session) return <Navigate to="/login" />;

  // spec §74: mobil dostává fokusovaný shell (přehled / rozhodnutí / Jarvis)
  if (isMobile) {
    return (
      <RealtimeProvider enabled>
        <MobileShell>
          <Outlet />
        </MobileShell>
      </RealtimeProvider>
    );
  }

  return (
    <RealtimeProvider enabled>
      <div className="flex min-h-screen">
        <NavRail />
        <main className="min-w-0 flex-1 px-5 py-5 lg:px-8 lg:py-7">
          <Outlet />
        </main>
        <CommandPalette />
        <JarvisOverlay />
      </div>
    </RealtimeProvider>
  );
}
